import React from "react";
import { Row, Col, Input, DatePicker } from "antd";
import moment from "moment";

const dateFormat = "MM/YY";

/**
 * ForteCardPayment - Card payment component for Forte processor
 * Uses separate inputs for card number, date picker for expiration, and CVV input
 */
const CardPayment = (props) => {
  const {
    cardNumber,
    setCardNumber,
    expiry,
    setExpire,
    cvc,
    setCvc,
    errorField = [],
    setErrorField,
  } = props;

  // Ensure errorField is always an array
  const safeErrorField = Array.isArray(errorField) ? errorField : [];

  const handleCardNumberChange = (e) => {
    let value = e.target.value.replace(/\D/g, ''); // Remove non-digits
    // Format with spaces every 4 digits
    value = value.replace(/(\d{4})(?=\d)/g, '$1 ');
    // Limit to 19 characters (16 digits + 3 spaces)
    value = value.slice(0, 19);
    if (setErrorField && safeErrorField.includes("cardNumber")) {
      const newErrList = safeErrorField.filter((x) => x !== "cardNumber");
      setErrorField([...newErrList]);
    }
    setCardNumber(value);
  };

  const handleCvcChange = (e) => {
    let value = e.target.value.replace(/\D/g, ''); // Remove non-digits
    value = value.slice(0, 4); // Max 4 digits for CVV
    if (setErrorField && safeErrorField.includes("cvc")) {
      const newErrList = safeErrorField.filter((x) => x !== "cvc");
      setErrorField([...newErrList]);
    }
    setCvc(value);
  };

  const handleExpiryChange = (date, dateString) => {
    if (setErrorField && safeErrorField.includes("expiry")) {
      const newErrList = safeErrorField.filter((x) => x !== "expiry");
      setErrorField([...newErrList]);
    }
    setExpire(dateString);
  };

  // Disable past months
  const disabledDate = (current) => {
    return current && current < moment().startOf('month');
  };

  return (
    <div className="block">
      <Row gutter={16}>
        <Col xs={24} sm={24}>
          <div style={{ paddingBottom: "5px", textAlign: "left" }}>Card Number*</div>
          <Input
            placeholder="1234 5678 9012 3456"
            value={cardNumber || ""}
            onChange={handleCardNumberChange}
            className={
              safeErrorField.includes("cardNumber")
                ? `common-input-error`
                : `common-input`
            }
            style={{ height: 40 }}
          />
        </Col>
      </Row>
      <Row gutter={16} style={{ marginTop: 10 }}>
        <Col xs={24} sm={12}>
          <div style={{ paddingBottom: "5px", textAlign: "left" }}>Expiration*</div>
          <DatePicker
            picker="month"
            format={dateFormat}
            placeholder="MM/YY"
            value={expiry ? moment(expiry, dateFormat) : null}
            onChange={handleExpiryChange}
            disabledDate={disabledDate}
            style={{ width: "100%", height: 40 }}
            className={
              safeErrorField.includes("expiry")
                ? `common-input-error`
                : `common-input`
            }
          />
        </Col>
        <Col xs={24} sm={12}>
          <div style={{ paddingBottom: "5px", textAlign: "left" }}>CVV*</div>
          <Input
            placeholder="123"
            value={cvc || ""}
            onChange={handleCvcChange}
            className={
              safeErrorField.includes("cvc")
                ? `common-input-error`
                : `common-input`
            }
            style={{ height: 40 }}
          />
        </Col>
      </Row>
    </div>
  );
};

export default CardPayment;
